import React, {createContext, useContext, useEffect, useState} from "react";
import * as GroupAPI from "../../service/group.service";
import * as FriendAPI from "../../service/friend.service";
import useFetch, {CachePolicies} from "use-http";
import {AppContext} from "./App.context";

export const QuickChatContext = createContext({});

export const QuickChatProvider = (props: any) => {
  const appCtx: any = useContext(AppContext);
  const [tabs, setTabs]: any = useState([]);
  const [activeTab, setActiveTab]: any = useState(null);
  const [topicID, setTopicID]: any = useState([]);
  const [newMessage, setNewMessage]: any = useState(
    appCtx?.quickChatHistory?.newMessage
  );
  const [groupsInfo, setGroupsInfo]: any = useState();
  const [friends, setFriends]: any = useState(null);
  const [groups, setGroups]: any = useState(null);
  const [isShowChatList, setIsShowChatList]: any = useState();

  const stateValue = {
    tabs: tabs,
    setTabs: setTabs,
    activeTab: activeTab,
    setActiveTab: setActiveTab,
    topicID: topicID,
    setTopicID: setTopicID,
    newMessage: newMessage,
    setNewMessage: setNewMessage,
    groupsInfo: groupsInfo,
    setGroupsInfo: setGroupsInfo,
    friends: friends,
    setFriends: setFriends,
    groups: groups,
    setGroups: setGroups,
    isShowChatList: isShowChatList,
    setIsShowChatList: setIsShowChatList,
  };

  const loadMyFriend = async (
    search: string,
    limit: number,
    offset: number
  ) => {
    const { data } = await FriendAPI.findMyFriend(search, limit, offset);
    return data;
  };

  const loadMyGroup = async (search: string, limit: number, offset: number) => {
    const { data } = await GroupAPI.findMyGroup(search, limit, offset, null);
    return data;
  };

  const myGroupsAPI = useFetch(
    window.__RUNTIME_CONFIG__.REACT_APP_PLAYME_URL + "/api/v1/users/all-groups",
    {
      cachePolicy: CachePolicies.NO_CACHE,
    }
  );

  const setAppCtxData = () => {
    const QCHistory = {
      tabs: tabs,
      activeTab: activeTab,
      topicID: topicID,
      newMessage: newMessage,
      isShowChatList: isShowChatList,
    };

    appCtx.setQuickChatHistory(QCHistory);
  };

  useEffect(() => {
    setAppCtxData();
  }, [tabs, activeTab, topicID, newMessage, isShowChatList]);

  useEffect(() => {
    let mounted = true;

    const initQuickChatData = async () => {
      if (appCtx.quickChatHistory !== null) {
        const oldQuickChatState = appCtx.quickChatHistory;

        setTabs(oldQuickChatState.tabs);
        setActiveTab(oldQuickChatState.activeTab);
        setTopicID(oldQuickChatState.topicID);
        // setNewMessage(oldQuickChatState.newMessage);
        // console.log('set new');

        setIsShowChatList(oldQuickChatState.isShowChatList);
      } else {
        // appCtx.setShowChatList(true);
      }
      try {
        const myFriends = await loadMyFriend("", -1, 0);
        const myGroups = await loadMyGroup("", -1, 0);
        const { groups } = await myGroupsAPI.get();

        setFriends(
          [...myFriends?.data].map((data) => {
            return data?.friend;
          })
        );

        setGroups(myGroups?.groups);
        setGroupsInfo(groups);

        // console.log("friends");
        // console.log(
        //   [...myFriends?.data].map((data) => {
        //     return data?.friend;
        //   })
        // );
        // console.log("groups");
        // console.log(myGroups.groups);

        // console.log("all groups");
        // console.log(groups);
      } catch (error) {
        console.error(error);
      }
    };

    if (mounted) {
      initQuickChatData();
    }

    return () => {
      mounted = false;
      myGroupsAPI.abort();
    };
  }, []);

  return (
    <QuickChatContext.Provider value={stateValue}>
      {props.children}
    </QuickChatContext.Provider>
  );
};
